import { DialogProps } from '@material-ui/core';
import { useFormSubmit } from 'framework/hooks/useFormSubmit';
import { inventoryItemsCommand_addReservation } from 'gen/ApiClient';
import React from 'react';
import { SelectPatientByIdForm } from 'shared/patientSearch/SelectPatientByIdForm';

interface IProps extends DialogProps {
	confirm: VoidFunction;
	cancel: VoidFunction;
	inventoryItemId: string;
}

export const ReserveForPatientForm = ({ inventoryItemId, confirm, ...rest }: IProps) => {
	const [link, isSubmitting] = useFormSubmit(inventoryItemsCommand_addReservation);

	const onConfirm = async (patientId: string) => {
		const r = await link({ inventoryItemId: inventoryItemId, patientId: patientId });
		if (r.isSuccess) {
			confirm();
		}
	};

	return (
		<SelectPatientByIdForm
			{...rest}
			confirm={onConfirm}
			isSubmitting={isSubmitting}
		/>
	);
};
